import React, { useContext, useEffect, useState } from "react";
import {
  IonButtons,
  IonButton,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonItem,
  IonLabel,
  IonInput,
  IonToast,
  IonText,
  IonPage,
  IonContent,
  IonCol,
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonAvatar,
  IonCardHeader,
  IonList,
  IonSpinner,
  IonIcon,
  IonBackButton,
} from "@ionic/react";
import { useHistory } from "react-router";
import ExploreContainer from "../../components/ExploreContainer";

import * as ApiService from "./../../services/ApiService";
import "./Users.css";
import UsersComponent from "../../components/UsersComponent";
import {
  ApplicationContext,
  ProviderContext,
  ProviderContextProvider,
} from "../../ApplicationState";
import Header from "../../components/Header/Header";
import { addCircle, arrowBackCircleSharp } from "ionicons/icons";

const Users: React.FC = (props: any) => {
  return (
    <IonPage>
      <Header />
       <IonHeader>
                      <IonToolbar color="light">
                          <IonButtons slot="start">
                              <IonBackButton
                                  text="Go Back"
                                  icon={arrowBackCircleSharp}
                                  defaultHref="/"
                              />
                          </IonButtons>
                          <IonTitle>Users</IonTitle>
                      </IonToolbar>
                  </IonHeader>
      <IonContent className="ion-padding">
        <IonButton routerLink={"/register"} routerDirection="none">
          Register New User <IonIcon icon={addCircle} />
        </IonButton>
        {/* <IonItem button routerLink={"/register"} routerDirection="none">Register New User</IonItem> */}
        <UsersComponent type="Users" />
      </IonContent>
    </IonPage>
  );
};

export default Users;
